import { render, staticRenderFns } from "./AllocatedIPAddresses.vue?vue&type=template&id=605858e6&"
import script from "./AllocatedIPAddresses.vue?vue&type=script&lang=js&"
export * from "./AllocatedIPAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports